import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { SHIPPING_PRICES } from '@/lib/shippingConfig';

export interface ShippingSettings {
    centralPrice: number;
    remotePrice: number;
}

export const useShippingSettings = () => {
    const [settings, setSettings] = useState<ShippingSettings>({
        centralPrice: SHIPPING_PRICES.delivery.central,
        remotePrice: SHIPPING_PRICES.delivery.remote,
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const { data, error } = await supabase
                .from('site_settings')
                .select('key, value')
                .in('key', ['shipping_price_central', 'shipping_price_remote']);

            if (error) throw error;

            if (data && data.length > 0) {
                const centralVal = data.find(d => d.key === 'shipping_price_central')?.value;
                const remoteVal = data.find(d => d.key === 'shipping_price_remote')?.value;

                setSettings({
                    centralPrice: centralVal ? parseInt(centralVal) : SHIPPING_PRICES.delivery.central,
                    remotePrice: remoteVal ? parseInt(remoteVal) : SHIPPING_PRICES.delivery.remote,
                });
            }
        } catch (error) {
            console.error('Error loading shipping settings:', error);
        } finally {
            setLoading(false);
        }
    };

    return { settings, loading, refresh: fetchSettings };
};
